"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactIntl = require("react-intl");

var _default = (0, _reactIntl.defineMessages)({
  master: {
    id: "window.groups.guild.attributes.master",
    defaultMessage: "Master",
    description: ""
  },
  hometown: {
    id: "window.groups.guild.attributes.hometown",
    defaultMessage: "Hometown",
    description: ""
  },
  membersCount: {
    id: "window.groups.guild.attributes.membersCount",
    defaultMessage: "Members",
    description: ""
  },
  reputation: {
    id: "window.groups.guild.attributes.reputation",
    defaultMessage: "Reputation",
    description: ""
  },
  rating: {
    id: "window.groups.guild.attributes.rating",
    defaultMessage: "Rating",
    description: ""
  },
  invite: {
    id: "window.groups.guild.button.invite",
    defaultMessage: "Invite",
    description: ""
  },
  alliances: {
    id: "window.groups.guild.button.alliances",
    defaultMessage: "Alliances",
    description: ""
  },
  members: {
    id: "window.groups.guild.button.members",
    defaultMessage: "Members",
    description: ""
  },
  leave: {
    id: "window.groups.guild.button.leave",
    defaultMessage: "Leave",
    description: ""
  },
  dismiss: {
    id: "window.groups.guild.button.dismiss",
    defaultMessage: "Dismiss",
    description: ""
  }
});

exports.default = _default;